import { useState, useRef } from 'react';
import { Button, ButtonVariant } from '@/shared/components/Buttons';
import {
  Card,
  CardStyle,
  CardBody,
  CardContent,
} from '@/shared/components/Card';
import { Dialog } from '@/shared/components/Dialog';
import PopupIcon from '../../../assets/svg/SupportEmail.svg';

const SUPPORT_EMAIL = 'support@pozytron.com';

interface SupportModalProps {
  open: boolean;
  onClose: () => void;
  onConfirmCancel: () => void;
}

const SupportModal = ({
  open,
  onClose,
  onConfirmCancel: _onConfirmCancel,
}: SupportModalProps) => {
  const [copied, setCopied] = useState(false);
  const resetTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(SUPPORT_EMAIL).then(() => {
      setCopied(true);
      if (resetTimerRef.current) {
        clearTimeout(resetTimerRef.current);
      }
      resetTimerRef.current = setTimeout(() => setCopied(false), 5000);
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={380}>
      <Card style={CardStyle.Elevated} width={380}>
        <CardBody padding="large">
          <div className="flex flex-col items-center gap-6 text-center">
            <div className="flex items-center justify-center w-[137px] h-[137px]">
              <PopupIcon />
            </div>
            <CardContent
              title="Kontakt z pomocą techniczną"
              description={
                <>
                  Potrzebujesz pomocy? Skontaktuj się z naszym zespołem
                  wsparcia.
                  <br />
                  <span className="font-normal">E-mail:</span>{' '}
                  <span
                    // onClick={}
                    // href="mailto:support@pozytron.com"
                    className="text-bodyMedium font-medium text-center text-on-surface-variant"
                  >
                    support@pozytron.com
                  </span>
                </>
              }
              className="!px-0 !py-0 flex flex-col items-center !gap-2 !text-[#474A4C] [&>p]:!font-normal"
            />
            <div className="flex flex-row items-center justify-center gap-3 w-full px-5">
              <Button
                label="Anuluj"
                autoFocus={true}
                onClick={onClose}
                className="!bg-transparent border border-[#DCDDE0] !text-on-surface-variant hover:!bg-neutral-95 hover:border-neutral-70 w-full cursor-pointer !rounded-[8px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2a4455] focus-visible:ring-offset-1"
              />
              <Button
                label={copied ? 'Copied' : 'Kopiuj'}
                variant={ButtonVariant.Primary}
                onClick={handleCopy}
                className="w-full cursor-pointer !rounded-[8px]"
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Dialog>
  );
};
export default SupportModal;
